// THE FILE WAS AUTOGENERATED USING PHP-CONVERTER. PLEASE DO NOT EDIT IT!

import axios from 'axios';

export type ActivityReadModelOutput = {
  id: string;
  username: string;
  messageDetails: string;
  messagePreview: string;
  createdAt: string;
  type: ActivityTypeEnum;
  isInternal: boolean;
  attachments: IncomingAttachmentItemDto[];
};

export enum ActivityTypeEnum {
  INFO = 'info',
  CREATE = 'create',
  EDIT = 'edit',
  COMMENT = 'comment',
  ATTACHMENT = 'attachment',
  SUPPORT_REQUEST_MESSAGE = 'support_request_message',
}

export type DayOffCreateFromAdminInput = {
  id: string;
  reason: DayOffReasonEnum;
  date: string;
  forUser: string;
};

export type DayOffCreateFromMemberInput = {
  id: string;
  reason: DayOffReasonEnum;
  date: string;
};

export type DayOffForUserOutput = {
  forUser: UserShortOutput;
  daysOff: DayOffOutput[];
};

export type DayOffOutput = {
  id: string;
  reason: DayOffReasonEnum;
  date: string;
  approvedAt: string | null;
  status: DayOffStatusEnum;
  forUser: UserShortOutput;
  approvedBy: UserShortOutput | null;
};

export enum DayOffReasonEnum {
  Sick = 'Sick',
  Holiday = 'Holiday',
  ProfessionalServices = 'ProfessionalServices',
  WorkingFromHome = 'WorkingFromHome',
  SpecialRequest = 'SpecialRequest',
}

export enum DayOffStatusEnum {
  Pending = 'Pending',
  Approved = 'Approved',
  Declined = 'Declined',
}

export type DayOffUpdateInput = {
  reason: DayOffReasonEnum;
  forUser: string | null;
  date: string | null;
};

export type IncomingAttachmentItemDto = {
  id: string;
  link: string;
  name: string;
  contentType: string;
};

export type SupportRequestCustomerOutput = {
  name: string | null;
  email: string | null;
  code: string | null;
  customerRef: string | null;
};

export type SupportRequestOutput = {
  id: string;
  subject: string;
  createdAt: string;
  customer: SupportRequestCustomerOutput;
  messages: ActivityReadModelOutput[];
  status: string;
  isImportant: boolean;
  ticketRef: string | null;
  relatedSystem: SupportRequestSystemOutput | null;
  relatedProject: SupportRequestProjectOutput | null;
  deadline: string | null;
  firstReplyAt: string | null;
};

export type SupportRequestProjectOutput = {
  id: string;
  name: string | null;
  contractStatus: string | null;
};

export type SupportRequestSystemOutput = {
  id: string;
  contractStatus: string | null;
  modelNumber: string | null;
};

export type TeamCreateInput = {
  id: string;
  name: string;
  manager: string;
  members: string[];
};

export type TeamMemberWithDayOffCountOutput = {
  id: number;
  username: string;
  totalDaysOff: number;
  approvedDaysOff: number;
  pendingDaysOff: number;
  declinedDaysOff: number;
};

export type TeamOutput = {
  id: string;
  name: string;
  manager: UserShortOutput;
  members: UserShortOutput[];
};

export type TeamUpdateInput = {
  name: string;
  manager: string;
  members: string[];
};

export type UserShortOutput = {
  id: number;
  username: string;
};

export const apiDayOffDayOffPut = (dayOff: string, input: DayOffUpdateInput): Promise<DayOffOutput> => {
  return axios
    .put<DayOffOutput>(`/api/day_off/${dayOff}`, input)
    .then((response) => response.data);
}

export const apiDayOffDayOffApprovePut = (dayOff: string): Promise<DayOffOutput> => {
  return axios
    .put<DayOffOutput>(`/api/day_off/${dayOff}/approve`)
    .then((response) => response.data);
}

export const apiDayOffDayOffDeclinePut = (dayOff: string): Promise<DayOffOutput> => {
  return axios
    .put<DayOffOutput>(`/api/day_off/${dayOff}/decline`)
    .then((response) => response.data);
}

export const apiDayOffAskAsAdminPost = (input: DayOffCreateFromAdminInput): Promise<DayOffOutput> => {
  return axios
    .post<DayOffOutput>(`/api/day_off_ask_as_admin`, input)
    .then((response) => response.data);
}

export const apiDayOffAskAsMemberPost = (input: DayOffCreateFromMemberInput): Promise<DayOffOutput> => {
  return axios
    .post<DayOffOutput>(`/api/day_off_ask_as_member`, input)
    .then((response) => response.data);
}

export const apiDaysOffUserGet = (user: string): Promise<DayOffForUserOutput> => {
  return axios
    .get<DayOffForUserOutput>(`/api/days_off/${user}`)
    .then((response) => response.data);
}

export const apiDaysOffMineGet = (): Promise<DayOffOutput[]> => {
  return axios
    .get<DayOffOutput[]>(`/api/days_off_mine`)
    .then((response) => response.data);
}

export const apiTeamsGet = (filters?: any): Promise<CollectionResponse<TeamOutput>> => {
  return axios
    .get<CollectionResponse<TeamOutput>>(`/api/teams`, { params: filters })
    .then((response) => response.data);
}

export const apiTeamsPost = (input: TeamCreateInput): Promise<null> => {
  return axios
    .post<null>(`/api/teams`, input)
    .then((response) => response.data);
}

export const apiTeamsMyTeamWithDaysOffGet = (): Promise<TeamMemberWithDayOffCountOutput[]> => {
  return axios
    .get<TeamMemberWithDayOffCountOutput[]>(`/api/teams/my_team_with_days_off`)
    .then((response) => response.data);
}

export const apiTeamsIdGet = (id: string): Promise<TeamOutput> => {
  return axios
    .get<TeamOutput>(`/api/teams/${id}`)
    .then((response) => response.data);
}

export const apiTeamsIdDelete = (id: string): Promise<TeamOutput> => {
  return axios
    .delete<TeamOutput>(`/api/teams/${id}`)
    .then((response) => response.data);
}

export const apiTeamsTeamPut = (team: string, input: TeamUpdateInput): Promise<TeamOutput> => {
  return axios
    .put<TeamOutput>(`/api/teams/${team}`, input)
    .then((response) => response.data);
}

export type CollectionResponse<Resource extends {id: string}> = {
  'hydra:member': Resource[];
  'hydra:totalItems': number;
  'hydra:view': { '@id': string; 'hydra:last': string };
  'hydra:search': { 'hydra:mapping': any[] };
  'hydra:last': string;
};